module.exports = __webpack_public_path__ + "static/img/blog 1024x768.f1cdad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/blog/blog 1024x768.jpg
// module id = HGCI
// module chunks = 47